<template>
    <div class="mt--10">
        <template v-if="pageLoading">
            <p class="text--xs text--color-primary">
                Loading saved cards...
            </p>
        </template>

        <template v-else-if="pageErr">
            <p class="text--xs text-error-400">
                Error fetching saved cards...
            </p>
        </template>

        <template v-else>
            <template v-if="savedCards.length">
                <div 
                    v-for="item in savedCards" 
                    :key="item._id" 
                    class="border-b-light pb--10 pt--10 w-100"
                    :class="{ 'disabled': selectedCardId === item._id }"
                >
                    <div class="flex align-items-center justify-content-between">
                        <div>
                            <div class="flex align-items-start">
                                <span class="sc__icon">
                                    <CreditCard 
                                        class="w-auto max-w-full h-full"
                                        :type="item.cardType"
                                    />
                                </span>
                                <div>
                                    <p class="text-gray-800 text--semi--bold text--sm mb--0">
                                        {{ item.masked }}
                                    </p>
                                    <p class="text-gray-500 text--xs">
                                        Expiry: {{ item.expDate }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <BaseButton 
                            variant="ghost"
                            class="p--0"
                            prefix-icon
                            icon-name="delete"
                            variant-style="warning"
                            @submit="deleteCard(item)"
                        />
                    </div>
                </div>
            </template>

            <template v-else>
                <p class="text--sm text-gray-800">
                    You have no saved cards.
                </p>
            </template>
        </template>
    </div>
</template>

<script>
import {
    BaseButton,
} from "@/components/ui/index";
import { paymentHistoryHeaders } from "@/utils/dummy";
import CreditCard from "@/components/billings/CreditCard.vue";

export default {
    name: "SavedCards",

    components: {
        CreditCard,
        BaseButton,
    },

    data() {
        return {
            paymentHistoryHeaders,
            pageLoading: false,
            pageErr: false,
            selectedCardId: "",
        };
    },

    computed: {
        savedCards() {
            return this.$store.getters["subscription/savedCards"];
        },

        profile() {
            return this.$store.getters["auth/profile"];
        },

        accountPlan() {
            return this.$store.getters["subscription/subscriptionInfo"]?.plan || "free";
        },
    },

    async mounted() {
        await this.fetchSavedCards();
    },

    methods: {
        async fetchSavedCards() {            
            try {
                this.pageErr = false;
                this.pageLoading = true;

                await this.$store.dispatch("subscription/fetchSavedCards");
            } catch (error) {
                this.pageErr = true;
            } finally {
                this.pageLoading = false;
            }
        },

        async deleteCard(card) {
            try {
                if (this.savedCards.length === 1 && this.accountPlan !== "free") {
                    this.$emit("toggleDeleteInfoModal", { bool: true, cardId: card._id });
                    return;
                }

                this.selectedCardId = card._id;
                await this.$store.dispatch("subscription/removeCard", card._id);
                this.$toast.error("Card deleted");
            } catch (error) {
                const errMsg = error?.response?.data?.message || error.message;
                this.$toast.error(errMsg);
            } finally {
                this.selectedCardId = "";
            }
        },
    },
};
</script>